const urlParams = new URLSearchParams(window.location.search);
const searchQuery = decodeURIComponent(urlParams.get('q'));
const page_no = urlParams.get('page');
var searchKey = searchQuery;
var andIndex = searchQuery.indexOf("AND")
if (andIndex != -1){
  var productType = searchQuery.substring(0, andIndex).trim().split(":")[1].trim();
  searchKey = searchQuery.substring(andIndex + 4).trim();
}

const getSortKey = decodeURIComponent(urlParams.get('sort')) || 'default';
let sortParam = {}
if (getSortKey && getSortKey != 'default'){
  let parts = getSortKey.split(':');
  let sortKey = parts[0];
  let sortOrder = parts[1];
  sortParam = {
    [sortKey]: sortOrder
  }
}

let filterKeywords = [];

var customize_result = {
  "variants": []
}

const showLoader = () => {
  const loaderWrapper = document.createElement('div');
  loaderWrapper.classList.add('loader-wrapper-gaip');
  loaderWrapper.innerHTML = '<div class="lds-dual-ring-gaip"><small>Loading</small></div>';
  const blockLayout = document.querySelector('#displayProducts');
  blockLayout.appendChild(loaderWrapper);
};

const hideLoader = () => {
    const loaderWrapper = document.querySelector('.loader-wrapper-gaip');
    if (loaderWrapper) {
        loaderWrapper.remove();
    }
    // var parentLayout = document.querySelector(`.displayProducts`);
    // parentLayout.style.display = "initial";
};

// Function to fetch products based on search query
const fetchProducts = async (productType, searchKey) => {
  try {
    // Retrieve localStorage data
    var perPage = urlParams.get('per_page');
    if (perPage == null){
      perPage = 10;
    }
    const user_id = localStorage.getItem("gaip-client-id");
    let per_page = Number(perPage);
    
    let start = page_no != 1 && page_no != null ? (page_no-1) * per_page : 0;
    // const valuePickerWrapperElement = document.querySelector('.value-picker-wrapper');

    let memberId = localStorage.getItem("gaip-member-id") || "";
    const url = new URL(window.location);
    const params = url.searchParams;
    const dynamicFilter = params.get('dynamic_filter');
    let filters = [];
    if (dynamicFilter){
      filters = dynamicFilter.split('+').map(filter => filter);
    }
    if (!filters || filters.length < 1){
      filters = [];
    }
    
    const requestBody = {
          user_id: user_id,
          member_id: memberId,
          start: page_no != 1 && page_no != null ? (page_no-1) * 12 : 0,
          size: per_page,
          top_k: 3,
          sort: sortParam,
          categories: filters,
          dynamic_filtering: ["tags", "ai_tags"],
          flags: {
            "has_out_of_stock_variants": false
          },
          price_lower: -1,
          price_upper: -1
    };
    
    showLoader();
    
    const response = await fetch(`https://connector.personalizer.gigalogy.com/search?q=${encodeURIComponent(searchKey)}&product_type=${encodeURIComponent(productType)}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      throw new Error('Failed to fetch data from server');
    }

    const data = await response.json();
    hideLoader();
    // Assuming data contains variant IDs returned from the server
    displayProducts(data, per_page, start);
  } catch (error) {
    // Show default search results
    const defaultSearchResult = document.getElementById('default-search-results');
    defaultSearchResult.removeAttribute('style');
    const defaultSearchPagination = document.getElementById('default-search-pagination');
    defaultSearchPagination.removeAttribute('style');
    const defaultShowCountRange = document.getElementById('default-showing-count-range');
    defaultShowCountRange.removeAttribute('style');
    
    console.error('Error:', error);
    hideLoader();
    // Handle error (e.g., show error message to the user)
  }
};

if (searchQuery) {
   fetchProducts(productType ,searchKey);
}

const displayProducts = (products, per_page, start) => {
  var displayContainer = document.getElementById("displayProducts");
  var variants = products.variants;
  var total_size = products.total_size;
  // filterKeywords = [...new Set(Object.values(products.summary.keywords).flat())];
  let filterKeywords = Object.values(products.summary.keywords).flat();
  filterKeywords = new Set(filterKeywords.map(keyword => keyword.trim()));
  filterKeywords = Array.from(filterKeywords);

  const allNull = variants.every(element => element === null);
  if (variants.length > 0 && !allNull){
    const showingCountElement = document.querySelector('.collection__showing-count.hidden-pocket.hidden-lap');
    // Check if the element is found
    if (showingCountElement) {
        const text = `Showing ${start+1} - ${start + variants.length} of ${total_size} results`;
        showingCountElement.textContent = text;
    
        // Remove the 'display: none' style
        showingCountElement.style.display = 'block';
    }
    // Display per-page
    const labelElement = document.querySelector('label[for="showing-count"]');
    if (labelElement) {
        // Remove the 'display: none' style
        labelElement.style.display = 'block';
    }
  
    const generatePaginationBlock = (currentPage, totalPages, searchQuery, variants, per_page) => {
      let sortUrl = decodeURIComponent(getSortKey);
      
      let paginationHTMLBlock = `
        <div class="pagination">
          <div class="pagination__inner">
      `;
  
      if (currentPage == 1 && totalPages == currentPage){
        // Show no button
      }
      else if (currentPage == 1) {
        // Next page button
        paginationHTMLBlock += `
          <a class="pagination__next link" rel="next" title="次へ" data-page="${currentPage + 1}" href="/search?options%5Bprefix%5D=last&amp;page=${currentPage + 1}&amp;q=${searchQuery}&amp;type=product;per_page=${per_page}${sortUrl}">
            <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">次へ</font></font>
            <svg class="icon icon--arrow-right" viewBox="0 0 8 12" role="presentation">
              <path stroke="currentColor" stroke-width="2" d="M2 2l4 4-4 4" fill="none" stroke-linecap="square"></path>
            </svg>
          </a>
        `;
      } else if (currentPage == totalPages) {
        // Previous page button
        paginationHTMLBlock += `
          <a class="pagination__prev link" rel="prev" title="前へ" data-page="${currentPage - 1}" href="/search?options%5Bprefix%5D=last&amp;page=${currentPage - 1}&amp;q=${searchQuery}&amp;type=product;per_page=${per_page}${sortUrl}">
            <svg class="icon icon--arrow-left" viewBox="0 0 8 12" role="presentation">
              <path stroke="currentColor" stroke-width="2" d="M6 10L2 6l4-4" fill="none" stroke-linecap="square"></path>
            </svg>
            <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">前へ</font></font>
          </a>
        `;
      } else {
          // Previous page button
          paginationHTMLBlock += `
            <a class="pagination__prev link" rel="prev" title="前へ" data-page="${currentPage - 1}" href="/search?options%5Bprefix%5D=last&amp;page=${currentPage - 1}&amp;q=${searchQuery}&amp;type=product;per_page=${per_page};per_page=${per_page}">
              <svg class="icon icon--arrow-left" viewBox="0 0 8 12" role="presentation">
                <path stroke="currentColor" stroke-width="2" d="M6 10L2 6l4-4" fill="none" stroke-linecap="square"></path>
              </svg>
              <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">前へ</font></font>
            </a>
          `;
          // Next page button
          paginationHTMLBlock += `
            <a class="pagination__next link" rel="next" title="次へ" data-page="${currentPage + 1}" href="/search?options%5Bprefix%5D=last&amp;page=${currentPage + 1}&amp;q=${searchQuery}&amp;type=product;per_page=${per_page}">
              <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">次へ</font></font>
              <svg class="icon icon--arrow-right" viewBox="0 0 8 12" role="presentation">
                <path stroke="currentColor" stroke-width="2" d="M2 2l4 4-4 4" fill="none" stroke-linecap="square"></path>
              </svg>
            </a>
          `;
        }
  
        
        paginationHTMLBlock += `<div class="pagination__nav">`
  
        if (currentPage > 4) {
          paginationHTMLBlock += `
              <a href="/search?options%5Bprefix%5D=last&amp;page=1&amp;q=${searchQuery}&amp;type=product;per_page=${per_page}" data-page="1" class="pagination__nav-item link " title="Go to page 1">
                <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">1</font></font>
              </a>
              <span class="pagination__nav-item pagination__dot" style="cursor: text;">…</span>
          `;
        }
  
        if (currentPage == 4) {
          paginationHTMLBlock += `
              <a href="/search?options%5Bprefix%5D=last&amp;page=1&amp;q=${searchQuery}&amp;type=product;per_page=${per_page}" data-page="1" class="pagination__nav-item link " title="Go to page 1">
                <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">1</font></font>
              </a>
          `;
        }
        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
            if (i > 0 && i <= totalPages) {
                const activeClass = i === currentPage ? 'is-active' : '';
                paginationHTMLBlock += `
                    <a href="/search?options%5Bprefix%5D=last&amp;page=${i}&amp;q=${searchQuery}&amp;type=product;per_page=${per_page}" data-page="${i}" class="pagination__nav-item link ${activeClass}" title="Go to page ${i}">
                      <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">${i}</font></font>
                    </a>
                `;
            }
        }
  
        if (currentPage < totalPages - 3) {
            paginationHTMLBlock += `
                <span class="pagination__nav-item pagination__dot" style="cursor: text;">…</span>
                <a href="/search?options%5Bprefix%5D=last&amp;page=${totalPages}&amp;q=${searchQuery}&amp;type=product;per_page=${per_page}" data-page="${totalPages}" class="pagination__nav-item link " title="Go to page ${totalPages}">
                  <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">${totalPages}</font></font>
                </a>
            `;
        }
        if (currentPage == totalPages - 3){
            paginationHTMLBlock += `
                <a href="/search?options%5Bprefix%5D=last&amp;page=${totalPages}&amp;q=${searchQuery}&amp;type=product;per_page=${per_page}" data-page="${totalPages}" class="pagination__nav-item link " title="Go to page ${totalPages}">
                  <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">${totalPages}</font></font>
                </a>
            `;
        }
      
        paginationHTMLBlock += `</div>`
  
        // Closing tags
        paginationHTMLBlock += `
            </div>
          </div>
        `;
        const paginationContainer = document.querySelector('.customPaginationContainer');
        paginationContainer.innerHTML = paginationHTMLBlock;
  
        var urlParams = new URLSearchParams(window.location.search);
        var searchQuery = urlParams.get('q');
        var currentPage = urlParams.get('page');
        if (currentPage == null){
            currentPage = 1;
        }
        currentPage = Number(currentPage);
        
    
        // Add event listener to the parent element for handling button clicks
        paginationContainer.addEventListener('click', function(event) {
            // Check if the clicked element is a pagination button
            const target = event.target.closest('.pagination__prev, .pagination__next, .pagination__nav-item');
            if (target && !target.classList.contains('pagination__dot')) {
                event.preventDefault();
                const showingCountElement = document.querySelector('.collection__showing-count.hidden-pocket.hidden-lap');
        
                // Get the current page value from the data-page attribute of the closest pagination button
                const currentPage = parseInt(target.getAttribute('data-page'));
        
                // Call a function to handle the navigation to the new page
                handlePageNavigation(currentPage);
            }
        });
    
        function handlePageNavigation(newPage) {
            let sortUrl = `&sort=${encodeURIComponent(getSortKey)}`;
            if (!urlParams.get('sort')){
              sortUrl = '';
            }
            let dynamicFilterUrl = `&dynamic_filter=${encodeURIComponent(dynamicFilter)}`
            if (!urlParams.get('dynamic_filter')){
              dynamicFilterUrl = '';
            }
            // Construct the URL for the new page based on the clicked button
            const url = `/search?options%5Bprefix%5D=last&page=${newPage}&q=${searchQuery}&type=product&per_page=${per_page}${sortUrl}${dynamicFilterUrl}`;
        
            // Navigate to the new page by updating the window location
            window.location.href = url;
        }
    };
  
    
    var urlParams = new URLSearchParams(window.location.search);
    var searchQuery = urlParams.get('q');
    var currentPage = urlParams.get('page');
    if (currentPage == null){
      currentPage = 1;
    }
    currentPage = Number(currentPage);
    var totalPages = Math.ceil(total_size/per_page);
    generatePaginationBlock(currentPage, totalPages, searchQuery, variants, per_page);
  
    const valuePickerWrapperElement = document.querySelector('.value-picker-wrapper');
    if (valuePickerWrapperElement) {
        // Remove the 'display: none' style
        const perPageElement = document.querySelector('.hidden-phone');
        perPageElement.textContent = `${per_page} per page`;
        valuePickerWrapperElement.style.display = 'block';
    }
  
    // Add event listener to the parent element for handling button clicks
    valuePickerWrapperElement.addEventListener('click', function(event) {
        const target = event.target.closest('.value-picker__choice-item');
        if (target){
          const newPerPageValue = target.getAttribute('data-value');
          let sortUrl = `&sort=${encodeURIComponent(urlParams.get('sort'))}`;
          if (!urlParams.get('sort')){
              sortUrl = '';
          }
          let dynamicFilterUrl = `&dynamic_filter=${encodeURIComponent(dynamicFilter)}`
          if (!urlParams.get('dynamic_filter')){
            dynamicFilterUrl = '';
          }
          const url = `/search?options%5Bprefix%5D=last&page=1&q=${searchQuery}&type=product&per_page=${newPerPageValue}${sortUrl}${dynamicFilterUrl}`;
          window.location.href = url;
        }
    });
  
  
    // ---------------------- Sort Start ----------------------- //
    const sortWrapper = document.getElementById('sort-option-wrapper');
    const sortWrapperLabel = document.getElementById('sort-option-wrapper-label');
    // sortWrapper.style.display = 'block';
    // sortWrapperLabel.style.display = 'block'; // Uncomment this two lines to add search feature
    
    const sortButton = document.getElementById('search-sort-options');
    const sortOptionSelector = document.getElementById('display-by-selector-sort-options');
    const choiceItems = document.querySelectorAll('.value-picker-sort-options__choice-item');
    const selectedSortOption = document.getElementById('selected-sort-option');
  
    // Helper function to get query parameter
    function getQueryParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }
  
    // Helper function to update query parameter
    function updateQueryParameter(key, value) {
        var perPage = urlParams.get('per_page');
        if (perPage == null){
          perPage = 10;
        }
        let dynamicFilterUrl = `&dynamic_filter=${encodeURIComponent(dynamicFilter)}`
        if (!urlParams.get('dynamic_filter')){
          dynamicFilterUrl = '';
        }
        const baseUrl = `/search?options%5Bprefix%5D=last&page=1&q=${searchQuery}&type=product&per_page=${perPage}${dynamicFilterUrl}`;
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set(key, value);
        window.history.pushState({}, '', url);
        window.location.href = url;
    }
  
    const initialSortValue = getQueryParameter('sort') || 'default';
    const initialOption = document.querySelector(`.value-picker-sort-options__choice-item[data-value="${initialSortValue}"]`) || document.querySelector('.value-picker-sort-options__choice-item[data-value="default"]');
  
    if (initialOption) {
        selectedSortOption.textContent = initialOption.textContent.trim();
        initialOption.classList.add('is-selected');
    }
  
    sortButton.addEventListener('click', function() {
        const isHidden = sortOptionSelector.getAttribute('aria-hidden') === 'true';
        sortOptionSelector.setAttribute('aria-hidden', !isHidden);
        sortButton.setAttribute('aria-expanded', isHidden);
        sortOptionSelector.classList.toggle('show');
    });
    
    choiceItems.forEach(item => {
        item.addEventListener('click', function() {
            sortButton.setAttribute('aria-expanded', false);
            choiceItems.forEach(item => item.classList.remove('is-selected'));
            this.classList.add('is-selected');
            const selectedValue = this.getAttribute('data-value');
            selectedSortOption.textContent = this.textContent.trim();
            sortOptionSelector.setAttribute('aria-hidden', 'true');
            sortOptionSelector.classList.remove('show');
  
            updateQueryParameter('sort', selectedValue);
        });
    });
     // Handle outside click
     document.addEventListener('click', function(event) {
          if (!sortButton.contains(event.target) && !sortOptionSelector.contains(event.target)) {
              sortOptionSelector.setAttribute('aria-hidden', 'true');
              sortOptionSelector.classList.remove('show');
              sortButton.setAttribute('aria-expanded', false);
          }
      });
  
    // ---------------------- Sort End ----------------------- //
  
    // --------------- Dynamic Filtering Start --------------- //
    const dynamicFilterContainer = document.getElementById('dynamic-filter-container');
    dynamicFilterContainer.style.display = 'block';
    
    const listContainer = document.getElementById('dynamic-checkbox-list');
    listContainer.innerHTML = '';
  
    const url = new URL(window.location);
    const params = url.searchParams;
    const dynamicFilter = params.get('dynamic_filter');
    
    if (dynamicFilter) {
      const dynamicFilters = dynamicFilter.split('+').map(filter => filter.trim());
      dynamicFilters.forEach(filter => {
          let found = false;
          let k = filter;
  
          filterKeywords.forEach(keyword => {
              if (keyword.trim() === filter) {
                  found = true;
                  k = keyword;
                  return;
              }
          });
  
          if (!found) {
              filterKeywords.push(k);
          }
      });
    }
  
    
    // Add a clear all button before showing the Keywords
    if (dynamicFilter){
      const listItem = document.createElement('li');
      listItem.className = 'g-cheep';
    
      const checkbox = document.createElement('input');
      checkbox.id = `g-cheep-clear-all`;
      checkbox.value = 'clear_all';
      checkbox.type = 'checkbox';
    
      const label = document.createElement('label');
      label.htmlFor = checkbox.id;
      label.style.fontWeight = "bold";
      label.style.color = "black";
      label.innerText = "Clear All";
    
      listItem.appendChild(checkbox);
      listItem.appendChild(label);
      listContainer.appendChild(listItem);
    }
  
    if (filterKeywords.length > 0){
        filterKeywords.forEach((keyword, index) => {
          const listItem = document.createElement('li');
          listItem.className = 'g-cheep';
    
          const checkbox = document.createElement('input');
          checkbox.id = `g-cheep-${index + 1}`;
          checkbox.value = keyword;
          checkbox.type = 'checkbox';
    
          const label = document.createElement('label');
          label.htmlFor = checkbox.id;
          label.innerText = keyword;
    
          listItem.appendChild(checkbox);
          listItem.appendChild(label);
          listContainer.appendChild(listItem);
      });
    } else {
      listContainer.innerHTML = `<p style="text-align: center; margin: 0"> フィルタに使用できるキーが見つかりません <p>`
    }
    
  
    if (dynamicFilter) {
          const filters = dynamicFilter.split('+').map(filter => filter);
  
          filters.forEach(filter => {
              const checkboxes = document.querySelectorAll('#dynamic-checkbox-list input[type="checkbox"]');
              checkboxes.forEach(checkbox => {
                  if (checkbox.value.trim() === filter.trim()) {
                      checkbox.checked = true;
                      checkbox.closest('.g-cheep').classList.add('g-cheep_active');
                  }
              });
          });
  
          // Update the filter name with checked tags
          let parent = document.querySelector('.filter');
          let checkedInputs = parent.querySelectorAll('input[type="checkbox"]:checked');
          let text = Array.from(checkedInputs).map(input => `<p>${input.labels[0].innerText}</p>`);
  
          let filterName = parent.querySelector('.filter__name');
          filterName.style.color = text.length > 0 ? '#d5a02c' : 'gray';
    }
  
    // Toggle filter dropdown
      document.querySelectorAll('.filter__name').forEach(filterName => {
          filterName.addEventListener('click', function() {
              let filterList = this.nextElementSibling;
              if (filterList) {
                  if (filterList.style.display === 'block') {
                      filterList.style.display = 'none';
                  } else {
                      filterList.style.display = 'block';
                  }
                  this.closest('.filter').classList.toggle('filter_active');
              }
          });
      });
  
      // Close filter dropdown if clicked outside
      document.addEventListener('click', function(event) {
          document.querySelectorAll('.filter').forEach(filter => {
              let filterList = filter.querySelector('.filter__list');
              if (filterList && filterList.style.display === 'block') {
                  // Check if the click is outside the filter
                  if (!filter.contains(event.target)) {
                      filterList.style.display = 'none';
                      filter.classList.remove('filter_active');
                  }
              }
          });
      });
  
      // Style tags on checkbox change
      document.querySelectorAll('.g-cheep').forEach(cheep => {
          cheep.addEventListener('click', function() {
              const url = new URL(window.location);
              const params = url.searchParams;
              let dynamicFilter = params.get('dynamic_filter');
              let perPage = params.get('per_page');
              let sort = params.get('sort');
            
              let childInput = this.querySelector('input');
              if (childInput.checked) {
                  // Check if it's Clear All button
                  if (childInput.value == "clear_all"){
                    params.delete('dynamic_filter');
                    params.set('page', '1');
                    if (perPage && perPage != "null"){
                      params.set('per_page', perPage);
                    }
                    if (sort && sort != "null"){
                      params.set('sort', sort);
                    }
                    window.location = url.toString();
                    return;
                  } else {
                    this.classList.add('g-cheep_active');
                    if (dynamicFilter) {
                        const filters = dynamicFilter.split('+');
                        if (!filters.includes(childInput.value)) {
                            filters.push(childInput.value);
                            dynamicFilter = filters.join('+');
                        }
                    } else {
                        dynamicFilter = childInput.value;
                    }
                  }
                  
              } else {
                  this.classList.remove('g-cheep_active');
                  if (dynamicFilter) {
                      const filters = dynamicFilter.split('+').filter(filter => filter !== childInput.value);
                      dynamicFilter = filters.length ? filters.join('+') : null;
                  }
              }
      
              // Update the filter name with checked tags
              let parent = this.closest('.filter');
              let checkedInputs = parent.querySelectorAll('input[type="checkbox"]:checked');
              let text = Array.from(checkedInputs).map(input => `<p>${input.labels[0].innerText}</p>`);
      
              let filterName = parent.querySelector('.filter__name');
              // filterName.innerHTML = text.length > 0 ? text.join('') : '';
              filterName.style.color = text.length > 0 ? '#d5a02c' : 'gray';
      
              if (dynamicFilter) {
                  params.set('dynamic_filter', dynamicFilter);
              } else {
                  params.delete('dynamic_filter');
              }
              params.set('page', '1');
              if (perPage && perPage != "null"){
                params.set('per_page', perPage);
              }
              if (sort && sort != "null"){
                params.set('sort', sort);
              }
              window.location = url.toString();
          });
      });
    // ---------------- Dynamic Filtering End ---------------- //
    
    for (let variant of variants) {
        let product_labels = '';
        if (variant.product.tags){
          for (let tag of variant.product.tags) {
            if (tag.includes('__label:')) {
                product_labels += `<span class="product-label product-label--custom1">${tag.split('__label:').pop()}</span>`;
            }
            if (tag.includes('__label1:')) {
                product_labels += `<span class="product-label product-label--custom1">${tag.split('__label1:').pop()}</span>`;
            }
            if (tag.includes('__label2:')) {
                product_labels += `<span class="product-label product-label--custom2">${tag.split('__label2:').pop()}</span>`;
            }
          }
        }
        
        if (settings.show_discount && variant.price < variant.compare_at_price) {
            let savings = '';
            if (settings.discount_mode === 'percentage') {
                savings = `${((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price).toFixed()}%`;
            } else {
                savings = `<span>${(variant.compare_at_price - variant.price).toFixed(2)}</span>`;
            }
            variant_labels += `<span class="product-label product-label--on-sale">${savings}</span>`;
        }
        var show_secondary_media = false;
        // if ( settings.show_secondary_image && variantproduct.media.size > 1 ){
        //   show_secondary_media = true;
        // }
        
        let primary_media = variant.product.featuredImage;
        if (!primary_media){
            primary_media = {
                url : "https://placehold.co/600x400"
            }
        }
        var primary_image = primary_media.url;
        
        let url = variant.product.onlineStoreUrl ? variant.product.onlineStoreUrl : variant.product.onlineStorePreviewUrl;
  
        let ext_product_id = variant.product.id.split('/');
        let productId = ext_product_id[ext_product_id.length - 1];
  
        let productDiv = document.createElement("div");
        productDiv.classList.add("product-item");
        productDiv.classList.add('product-item--vertical');
        // productDiv.classList.add(section.id === 'blog-sidebar' ? 'product-item--compact' : '');
        var gridClassesArray = grid_classes.split(' ');
        gridClassesArray.forEach(function(className) {
            productDiv.classList.add(className);
        });
      
        productDiv.setAttribute('data-product-id', productId);
  
        let availableForSaleBlock = `
            <span class="product-item__inventory inventory inventory--high">在庫あり</span>
        `;
        
        if (!variant.availableForSale) {
            availableForSaleBlock = `
               <span class="product-item__inventory inventory">完売</span>
            `;
        }
      
        productDiv.innerHTML = `
              <a href="${url}" class="product-item__image-wrapper ${show_secondary_media ? 'product-item__image-wrapper--with-secondary' : ''}">
                <div class="aspect-ratio ${settings.product_image_size !== 'natural' ? 'aspect-ratio--' + settings.product_image_size : ''}" style="padding-bottom: ${100.0 / 1}%;">
                    <img class="product-item__primary-image lazyload image--fade-in" data-media-id="${primary_media.id}" data-src="${primary_media.url}" data-sizes="auto" alt="${primary_media.alt}">
                    ${show_secondary_media ? `
                        <img class="product-item__secondary-image lazyload image--fade-in" data-src="${secondary_image}" data-sizes="auto" alt="${secondary_media.alt}">
                    ` : ''}
                    <noscript>
                        <img src="${primary_image}" alt="${primary_media.alt}">
                    </noscript>
                </div>
               </a>
               <div class="product-item__info">
                  <div class="product-item__info-inner">
                      <a href="${url}" class="product-item__title text--strong link">${variant.product.title}</a>
                      <div class="product-item__price-list price-list">
                          ${variant.price < variant.compare_at_price ? 
                              (variant.compare_at_price_varies ? 
                                  `<span class="price price--highlight">から</span>
                                  <span class="price price--compare">${ variant.compare_at_price_min }</span>` : 
                                  `<span class="price price--highlight">${ variant.price }</span>
                                  <span class="price price--compare">${ variant.compare_at_price }</span>`) : 
                              (variant.price_varies ? 
                                  `<span class="price">から</span>` : 
                                  `<span class="price">¥${new Intl.NumberFormat().format(variant.price)}</span>`)}
                      </div>
                      ${availableForSaleBlock}
                  </div>
              </div>
        `;
        displayContainer.appendChild(productDiv);
    }
  } 

  if (variants.length == 0 || allNull){
    // let emptyResults = document.createElement("div");

    // const urlParams = new URLSearchParams(window.location.search);
    // const searchQuery = decodeURIComponent(urlParams.get('q'));
    // if (searchQuery != null){
    //   emptyResults.innerHTML = `
    //    <div class="empty-state">
    //     <p class="empty-state__heading heading h1">検索</p>
    //     <p class="empty-state__description">No results could be found for "${search_terms}"</p>

    //     <form class="empty-state__quick-form" action="${ routes_search_url }" method="get">
    //       <input type="hidden" name="type" value="product">

    //       <div class="form__connected-item">
    //         <div class="form__input-wrapper form__input-wrapper--labelled">
    //           <input id="search" type="text" class="form__field form__field--text" name="q" autocomplete="off" autocorrect="off">
    //           <label for="search" class="form__floating-label">商品名、キーワードで検索</label>
    //         </div>

    //         <button type="submit" class="form__connection button button--primary" aria-label="商品名、キーワードで検索">Search</button>
    //       </div>
    //     </form>

    //     <a href="${ routes_root_url }" class="empty-state__link link link--accented">または、ここをクリックしてトップに戻ります</a>
    //   </div>
    //   `
    // }else {
    //   emptyResults.innerHTML = ``
    // }
    
    // displayContainer.classList.remove("product-list");
    // displayContainer.classList.remove("product-list--collection");
    // const mainCollection = document.querySelector(".collection");
    // while (mainCollection.firstChild) {
    //     mainCollection.removeChild(mainCollection.firstChild);
    // }
    // mainCollection.appendChild(emptyResults);
    
    const mainCollection = document.querySelector(".customPaginationContainer");
    while (mainCollection.firstChild) {
        mainCollection.removeChild(mainCollection.firstChild);
    }

    const dynamicFilterContainer = document.getElementById('dynamic-filter-container');
    dynamicFilterContainer.style.display = 'none';


    const collectionShowingCount = document.querySelector('collection__toolbar-item.collection__toolbar-item--count.hidden-pocket');
    collectionShowingCount.style.display = 'none';

    
    // Show default search results
    const defaultSearchResult = document.getElementById('default-search-results');
    defaultSearchResult.removeAttribute('style');
    const defaultSearchPagination = document.getElementById('default-search-pagination');
    defaultSearchPagination.removeAttribute('style');
    const defaultShowCountRange = document.getElementById('default-showing-count-range');
    defaultShowCountRange.removeAttribute('style');
  }
}